/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-face-dissatisfied-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zM7.187 6.875a1.563 1.563 0 11-1.562 1.563 1.55 1.55 0 011.588-1.563h-.026zm6.026 8.075a3.75 3.75 0 00-6.425 0l-1.07-.625a5 5 0 018.563 0l-1.069.625zm-.4-4.95a1.563 1.563 0 110-3.125 1.563 1.563 0 010 3.125z"/>'
  }
})
